export default {
  tabs: [
    {
      // 该功能的入口在：评估师app-我的工单-跟进
      name: 'CustomerIntention',
      path: '/customerIntention',
      component: () => import('./src/CustomerIntention.vue'),
      meta: {
        title: '客户跟进',
      },
    },
  ],
}
